import React from 'react';
import { motion } from 'framer-motion';
import { MapPin, Clock, MessageCircle, Phone } from 'lucide-react';
import { LocationMap } from './LocationMap';
import { useBooking } from './BookingContext';
const info = [{
  icon: MapPin,
  label: 'Ubicación',
  value: <>
        96-02 37th Ave
        <br data-id="element-89" data-mp="2w80ajhhj6y5l" />
        Corona, NY 11368
      </>
}, {
  icon: Clock,
  label: 'Horario',
  value: <>
        Lunes a domingo
        <br data-id="element-90" data-mp="3swg2fk845jlv" />
        9:30 AM – 8:00 PM
      </>
}, {
  icon: MessageCircle,
  label: 'WhatsApp',
  value: <a href="https://wa.me/13478886047" target="_blank" rel="noreferrer" className="transition-colors hover:text-gold focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-champagne" data-id="element-91" data-mp="3oxfnicsrb145">
        (347) 888-6047
      </a>,
  highlight: true
}, {
  icon: Phone,
  label: 'Llámanos',
  value: <a href="tel:+13472422967" className="transition-colors hover:text-gold focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-champagne" data-id="element-92" data-mp="ghe1ir4mtmlx">
        (347) 242-2967
      </a>,
  highlight: true
}];
export function Contact() {
  const {
    openBooking
  } = useBooking();
  return <section id="contacto" className="max-w-2xl mx-auto px-6 pt-16 scroll-mt-24" data-id="element-93" data-mp="3ouxp9aauwdr5">
      {/* INFO STRIP */}
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-px bg-brand-border mb-9" data-id="element-94" data-mp="3b27vukt006k0">
        {info.map(cell => {
        const Icon = cell.icon;
        const isContactChannel = Boolean(cell.highlight);
        return <div key={cell.label} className="bg-warm-white px-4 py-6 text-center flex flex-col items-center" data-id="element-95" data-mp="313if4vcu8s5c">
              {isContactChannel ? <span className="metallic-gold-surface mb-3 flex h-11 w-11 items-center justify-center rounded-full border border-metallic-border shadow-[0_3px_9px_rgba(183,144,72,0.24)]" data-id="element-96" data-mp="361tpr8ayj6om">
                  <Icon className="h-5 w-5 text-white drop-shadow-[0_1px_1px_rgba(73,53,20,0.35)]" strokeWidth={1.7} data-id="element-97" data-mp="2w8340b67tacm" />
                </span> : <span className="mb-3 flex h-11 w-11 items-center justify-center" aria-hidden="true" data-id="element-98" data-mp="uedlfl5ive9b">
                  <Icon className="h-5 w-5 text-champagne-deep" strokeWidth={1.45} data-id="element-99" data-mp="23bc4r7doqo13" />
                </span>}
              <div className="font-body font-medium text-[10px] tracking-[3px] uppercase text-soft mb-1.5" data-id="element-100" data-mp="1ybzhwmmtdgyi">
                {cell.label}
              </div>
              <div className="font-serif text-dark text-base leading-snug" data-id="element-101" data-mp="1ud038aba65tv">{cell.value}</div>
            </div>;
      })}
      </div>

      <LocationMap data-id="element-102" data-mp="2m1tssynkovg4" />

      {/* CTA */}
      <motion.div initial={{
      opacity: 0,
      y: 24
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true,
      margin: '-80px'
    }} transition={{
      duration: 0.7
    }} className="relative overflow-hidden border border-metallic-border bg-dark px-7 py-11 text-center shadow-[0_16px_36px_rgba(44,33,24,0.2)] sm:px-12 sm:py-14" data-id="element-103" data-mp="2m0s4vtlgkegz">
        <span aria-hidden="true" className="pointer-events-none absolute -right-5 -top-16 select-none font-serif text-[260px] leading-none text-champagne/[0.08]" data-id="element-104" data-mp="35qkqyx1kyu0q">G</span>
        <div className="relative" data-id="element-105" data-mp="30xhvukh5ncif">
          <div className="mx-auto mb-5 flex items-center justify-center gap-3" aria-hidden="true" data-id="element-106" data-mp="38bacgkbxn6us">
            <span className="h-px w-10 bg-metallic-border/65 sm:w-16" data-id="element-107" data-mp="3d8sctmbvwdr6" />
            <span className="h-2 w-2 rotate-45 bg-metallic-border" data-id="element-108" data-mp="3i8oirr456f9d" />
            <span className="h-px w-10 bg-metallic-border/65 sm:w-16" data-id="element-109" data-mp="3i7delq6sb5hq" />
          </div>
          <p className="font-body font-semibold text-[10px] tracking-[5px] uppercase text-gold-light mb-4" data-id="element-110" data-mp="3mbtfte5gdoqm">
            Tu transformación comienza hoy
          </p>
          <h2 className="font-serif font-light text-warm-white text-3xl sm:text-[42px] leading-[1.2] mb-4" data-id="element-111" data-mp="2a41py1u19x">
            Reserva tu cita y
            <br data-id="element-112" data-mp="4ujztmluhvk4" />
            <em className="italic text-gold-light" data-id="element-113" data-mp="4w4k8jeg3y49">siente la diferencia.</em>
          </h2>
          <p className="font-body font-light text-cream/80 text-sm leading-[1.85] max-w-md mx-auto mb-8" data-id="element-114" data-mp="9uxwy9lwrl3d">
            No importa desde dónde llegues. Si buscas calidad premium, atención personalizada y salir
            del salón sintiéndote absolutamente espectacular — este es tu lugar. Cupos limitados por
            semana para garantizar una atención de primera.
          </p>

          <motion.button type="button" onClick={openBooking} whileHover={{
          y: -2
        }} className="metallic-reserve-button inline-block px-9 py-4 text-white font-body font-semibold text-[10px] tracking-[4px] uppercase outline-none focus-visible:ring-2 focus-visible:ring-gold-light focus-visible:ring-offset-2 focus-visible:ring-offset-dark sm:px-11" data-id="element-115" data-mp="14plkb7uha45">
            Reservar Mi Cita Ahora
          </motion.button>

          <p className="font-body text-cream/85 text-sm mt-6 tracking-[1px]" data-id="element-116" data-mp="3ee3r3slsk589">
            Escríbenos por{' '}
            <a href="https://wa.me/13478886047" target="_blank" rel="noreferrer" className="font-semibold text-gold-light underline-offset-4 transition-colors hover:text-warm-white hover:underline" data-id="element-117" data-mp="3ncp8vljfvg7z">
              WhatsApp (347) 888-6047
            </a>
            {' '}o llámanos al{' '}
            <a href="tel:+13472422967" className="font-semibold text-gold-light underline-offset-4 transition-colors hover:text-warm-white hover:underline" data-id="element-118" data-mp="2kjth4ei4jwx2">
              (347) 242-2967
            </a>
          </p>
          <p className="font-body font-light text-cream/60 text-xs mt-2 tracking-[0.5px]" data-id="element-119" data-mp="2bjeunbtfcbrz">
            Lunes a domingo · 9:30 AM – 8:00 PM · Queens, New York
          </p>
        </div>
      </motion.div>
    </section>;
}